import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { MotifButton } from '@ey-xd/motif-react';
import { Field } from 'redux-form';
import * as formHelpers from '../../scripts/formHelpers';
import * as Constants from '../../constants/other';

/**
 * ServicesScopeHeader component
 * @param {Object} props - The component properties
 * @returns {JSX.Element} The rendered component
 */
const ServicesScopeHeader = ({
  handleReportPeriodSelection,
  gridCurrentState,
  toggleServiceScopeModal,
  isAuditOnlyClient,
  defaultReportPeriod,
  reportPeriods,
}) => {
  // Combine yearOptions with quarterOptionValues
  const combinedOptions = [];
  reportPeriods?.forEach((periodDescription) => {
    // Period Description is in format like "Q1 2023"
    const [quarter, year] = periodDescription.split(' ');
    combinedOptions.push({
      key: `${quarter} ${year}`,
      text: `${quarter} ${year}`,
      value: `${quarter} ${year}`,
    });
  });

  let updateServicesScopeStatus = false;
  // Check if there is no reit selected
  if (!gridCurrentState || gridCurrentState.length === 0) {
    updateServicesScopeStatus = false;
  }
  // Check if there is any reit selected
  else if (gridCurrentState && gridCurrentState.length > 0) {
    if (gridCurrentState.some((x) => x.reitSelection == true)) {
      updateServicesScopeStatus = true;
    }
  }

  return (
    <>
      {/* Header area */}
      <div style={{ minHeight: '24px' }}></div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div
          className="mr-3 mt-auto"
          style={{ flex: '0 0 auto', marginBottom: '50px', minWidth: '200px' }}
        >
          <Field
            name="reportPeriod"
            label="Report Period"
            type="select"
            testingData={{ label: 'lblReportPeriod', div: 'divReportPeriod' }}
            onChange={handleReportPeriodSelection}
            options={combinedOptions}
            component={formHelpers.SingleSelectComponent}
            defaultValue={defaultReportPeriod ? defaultReportPeriod : ''}
          />
        </div>
        <div style={{ flex: '1' }}></div>
        <div style={{ width: 'fit-content', marginBottom: '10px' }}>
          <MotifButton
            variant="primary"
            onClick={toggleServiceScopeModal}
            disabled={!updateServicesScopeStatus || isAuditOnlyClient}
            data-testid="btnUpdateServicesScope"
          >
            Update Services Scope
          </MotifButton>
        </div>
      </div>
    </>
  );
};

ServicesScopeHeader.propTypes = {
  handleReportPeriodSelection: PropTypes.func.isRequired,
  gridCurrentState: PropTypes.array,
  toggleServiceScopeModal: PropTypes.func.isRequired,
  isAuditOnlyClient: PropTypes.bool,
  defaultReportPeriod: PropTypes.string,
  reportPeriods: PropTypes.array,
};

export default ServicesScopeHeader;
